import { actionTypes} from '../actions/blogPosts'
import createAsyncReducer from './HOCreducer'

export default createAsyncReducer(actionTypes, true)
